import { useDispatch, useSelector } from 'react-redux';
import { updateRole } from '../store/userReducer';

export const useUser = () => {
    const dispatch = useDispatch();
    const user = useSelector((state) => state.user);

    const onChangeRole = (roleUuid) => {
        dispatch(updateRole(roleUuid));
    };

    return {
        user,
        onChangeRole
    };
};
